<p-card>
  <div class="row flex">
    <div class="col-12">
      <h1 class="mb-3">Carteras</h1>
      <p class="mb-3 text-color-secondary">
        Consulta y gestiona la información detallada de los créditos otorgados en las diferentes carteras, incluyendo datos clave del cliente,
        contrato, estado económico, y condiciones del arrendamiento. Utiliza los filtros para encontrar rápidamente la
        información necesaria.
      </p>
    </div>
    <p-toast></p-toast>
  </div>

  <div class="flex col-12" *ngIf="loading; else content" style="display: flex; flex-wrap: wrap;">
    <div class="col-4" *ngFor="let item of [1,2]">
      <div class="hover-style">
        <p-card class="card-wallet">
          <h3 class="main-title title-styled">
            <p-skeleton width="8rem" />
          </h3>
          <div class="flex flex-column gap-3">
            <div class="p-card-container wallet-section">
              <p class="p-card-text">Creado por: <p-skeleton width="8rem" /></p>
            </div>
            <div class="p-card-container wallet-section">
              <p class="p-card-text">Valor cartera: <p-skeleton width="6rem" /></p>
              <p class="p-card-text">Cartera sin accesorios: <p-skeleton width="6rem" /></p>
            </div>
            <div class="p-card-container wallet-section">
              <p class="p-card-text">Arrendamientos activos: <p-skeleton width="4rem" /></p>
            </div>
          </div>
        </p-card>
      </div>
    </div>
  </div>

  <ng-template #content>
    <!-- Lentes (F36): la renta siempre cuenta; lo demás se enciende y apaga. Una sola vez para todas
         las tarjetas, y con stopPropagation porque cada tarjeta navega al hacer clic. -->
    <div class="col-12 lens-row" (click)="$event.stopPropagation()">
      <span class="lens-label">Incluir en la cartera:</span>
      <span class="field-checkbox"><p-checkbox [(ngModel)]="lens.accessories" [binary]="true" inputId="wlAcc"></p-checkbox><label for="wlAcc">Accesorios</label></span>
      <span class="field-checkbox"><p-checkbox [(ngModel)]="lens.residual" [binary]="true" inputId="wlRes"></p-checkbox><label for="wlRes">Residual</label></span>
      <span class="field-checkbox"><p-checkbox [(ngModel)]="lens.mora" [binary]="true" inputId="wlMora"></p-checkbox><label for="wlMora">Mora</label></span>
    </div>

    <div class="flex col-12" style="display: flex; flex-wrap: wrap;">

      <div class="col-4" *ngIf="isAdmin">
        <div class="hover-style" (click)="goToAdminDetails()">
          <p-card class="card-wallet">
            <h3 class="main-title title-styled"> 
              &nbsp; <i class="fas fa-clipboard-list"></i> &nbsp;
              General
            </h3>
            <div class="flex flex-column gap-3">
              <div class="p-card-container wallet-section">
                <p class="p-card-text">Creado para: <strong>Super Admins</strong></p>
              </div>
              <div class="p-card-container wallet-section">
                <p class="p-card-text">Valor cartera: <strong>{{ walletAdmin.wallet | currency }}</strong></p>
                <p class="p-card-text">Cartera sin accesorios: <strong>{{ walletAdmin.walletWithoutAccessories | currency }}</strong></p>
                <p class="p-card-text" *ngIf="walletAdmin.components">Con la lente: <strong>{{ carteraFiltrada(walletAdmin.components) | currency }}</strong></p>
              </div>
              <div class="p-card-container wallet-section">
                <p class="p-card-text">Arrendamientos activos: <strong>{{ walletAdmin .leaseCount }}</strong></p>
              </div>
            </div>
          </p-card>
        </div>
      </div>

      <!-- Cards de Wallets -->
      <div class="col-4" *ngFor="let wallet of wallets">
        <div class="hover-style" (click)="goToWalletDetails(wallet)">
          <p-card class="card-wallet">
            <h3 class="main-title title-styled"> &nbsp; <i class="fas fa-clipboard-list"></i> &nbsp; {{ wallet.wallet.name }}</h3>
            <div class="flex flex-column gap-3">
              <div class="p-card-container wallet-section">
                <p class="p-card-text">Creado por: <strong>{{ wallet.wallet.createdBy.names + ' ' + wallet.wallet.createdBy.lastNames }}</strong></p>
              </div>
              <div class="p-card-container wallet-section">
                <p class="p-card-text">Valor cartera: <strong>{{ wallet.amounts.wallet | currency }}</strong></p>
                <p class="p-card-text">Cartera sin accesorios: <strong>{{ wallet.amounts.walletWithoutAccessories | currency }}</strong></p>
                <p class="p-card-text" *ngIf="wallet.amounts.components">Con la lente: <strong>{{ carteraFiltrada(wallet.amounts.components) | currency }}</strong></p>
              </div>
              <div class="p-card-container wallet-section">
                <p class="p-card-text">Arrendamientos activos: <strong>{{ wallet.amounts.leaseCount }}</strong></p>
              </div>
            </div>
          </p-card>
        </div>
      </div>

    </div>

    <ng-template #noWallets>
      <p>No hay carteras disponibles.</p>
    </ng-template>
    
  </ng-template>
</p-card>
